import { FC } from "react";
import { IResolveFATServiceOrderFormSchema } from "./schema";

const ProductInfoSummary: FC<{ data: IResolveFATServiceOrderFormSchema["productCharacteristics"], values: IResolveFATServiceOrderFormSchema, }> = ({ data, values }) => (
  <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-6 divide-y divide-gray-200">
    <div className=''>   
      <span className="text-xs font-light">Product Characteristics</span>
      <div className='grid grid-cols-3 gap-6 mt-2'>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Operating Voltage
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.operatingVoltage || "N/A"} V
          </div>
        </div>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Operating Current
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.operatingCurrent || "N/A"} A
          </div>
        </div>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Frequency
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.frequency || "N/A"} Hz
          </div>
        </div>
        <div className="col-span-1 col-start-1">
          <span className="block text-sm font-light text-gray-700">
            Pulse (kWh)
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.energy || "N/A"}
          </div>
        </div>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Pulse (KVArh)
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.reactiveEnergy || "N/A"}
          </div>
        </div>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Mode Of Payment
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.modeOfPayment || "N/A"}
          </div>
        </div>    
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Standards
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.standards || "N/A"}
          </div>
        </div>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Technology
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.technology || "N/A"}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ProductInfoSummary;